import { render } from "./Variant_Pathogenicity.vue?vue&type=template&id=707c5df1"
import script from "./Variant_Pathogenicity.vue?vue&type=script&lang=js"
export * from "./Variant_Pathogenicity.vue?vue&type=script&lang=js"

import "./Variant_Pathogenicity.vue?vue&type=style&index=0&id=707c5df1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__